<script setup>
const props = defineProps({
	title: {
		type: String,
		required: true
	},
	icon: {
		type: String,
		required: true
	},
	active: {
		type: Boolean,
		default: false
	}
});
</script>

<template>
  <button
    class="filtersChip abBtn abBtn--whiteBlue"
    :class="{ chipActive: active }"
    tabindex="-1"
  >
    <i :class="`icon ${icon}`" />
    <span>{{ title }}</span>
  </button>
</template>
